import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';

const LanguageToggle = ({ className = '', style = {} }) => {
  const [open, setOpen] = useState(false);
  const { currentLanguage, changeLanguage } = useLanguage();

  const languages = [
    { code: 'de', short: 'DE', name: 'German', flag: 'https://flagcdn.com/w20/de.webp' },
    { code: 'en', short: 'EN', name: 'English', flag: 'https://flagcdn.com/w20/gb.webp' },
  ];

  const currentLang = languages.find((l) => l.code === currentLanguage);
  const otherLangs = languages.filter((l) => l.code !== currentLanguage);

  const handleChangeLanguage = (code) => {
    changeLanguage(code);
    setOpen(false);
  };

  return (
    <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 9999, ...style }} className={className}>
      {/* Main button */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          background: 'white',
          padding: '8px 14px',
          borderRadius: '8px',
          border: '1px solid #ddd',
          cursor: 'pointer',
          boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
          fontSize: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          minWidth: '70px',
          justifyContent: 'space-between',
          fontWeight: '500',
          fontFamily: 'Lato, sans-serif'
        }}
        title={`Current language: ${currentLang.name}`}
        aria-label={`Language selector. Current: ${currentLang.name}`}
      >
        <img
          src={currentLang.flag}
          alt={currentLang.name}
          style={{ width: '20px', height: '14px', objectFit: 'cover', borderRadius: '2px' }}
        />
        <span>{currentLang.short}</span>
        {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
      </button>

      {/* Dropdown */}
      {open && (
        <div
          style={{
            marginBottom: '6px',
            background: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            padding: '6px 0',
            minWidth: '140px',
            position: 'absolute',
            bottom: '110%',
            right: 0
          }}
        >
          {otherLangs.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleChangeLanguage(lang.code)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                width: '100%',
                padding: '8px 14px',
                background: 'transparent',
                border: 'none',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '16px',
                color: '#333',
                transition: 'all 0.2s ease',
                fontFamily: 'Lato, sans-serif'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f2f2f2';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
              title={`Switch to ${lang.name}`}
              aria-label={`Switch to ${lang.name}`}
            >
              <img
                src={lang.flag}
                alt={lang.name}
                style={{ width: '20px', height: '14px', objectFit: 'cover', borderRadius: '2px' }}
              />
              {lang.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageToggle;
